import src from "IMAGE";
export default { src, width: 256, height: 256, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAJklEQVR42tXPMREAAAzCQPzLBQH0EFB2hmy/BJL8RdJoIG2ArDRw2M/1+0rboMoAAAAASUVORK5CYII="};
